import methods from '@/consts/reportAggregateMethods'
import targets from '@/consts/reportAggregateTargets'

export default function (cli) {
  return {
    categories (date) {
      let data = {
        'to_date': date,
        'from_date': date,
        'method': methods.DATE,
        'target': targets.CATEGORY,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/aggregate/`).query(data)
    },
    payments (date) {
      let data = {
        'to_date': date,
        'from_date': date,
        'method': methods.HOUR,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/aggregate/`).query(data)
    },
    dailys (date) {
      let data = {
        'date': date,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/daily/`).query(data)
    },
    details (fromDate, toDate, method, target, mode) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'method': method,
        'target': target,
        'mode': mode,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/detail/`).query(data)
    },
    paymentAnalyzes (fromDate, toDate, method) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'method': method,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/payment-analyze/`).query(data)
    },
    times (fromDate, toDate, mode) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'mode': mode,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/payment-time/`).query(data)
    },
    salesAnalyzes (fromDate, toDate, method) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'method': method,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/sales-analyze/`).query(data)
    },
    salesStaffs (fromDate, toDate, method) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'method': method,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/sales-staff/`).query(data)
    },
    salesWeekdays (fromDate, toDate, target) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'target': target,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/sales-weekday/`).query(data)
    },
    cashNotes (fromDate, toDate, method) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'method': method,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/cash-note/`).query(data)
    },
    audits (fromDate, toDate, classification) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
        'classification': classification,
        'target': targets.PAYMENT,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/audit/`).query(data)
    },
    reportShopSalesGadget (fromDate) {
      let data = {
        'target_date': fromDate,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/shop-group/shop-sales-gadget/`).query(data)
    },
    reportShopSalesAnalyze (fromDate, toDate) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/shop-group/sales-analyze/`).query(data)
    },
    reportShopSalesMonth (fromDate, toDate) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/shop-group/sales-month/`).query(data)
    },
    shopPaymentNote (fromDate, toDate) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/shop-group/shop-payment-note/`).query(data)
    },
    shopMenuSales (fromDate, toDate) {
      let data = {
        'from_date': fromDate,
        'to_date': toDate,
      }
      return cli.get(`${cli.crmApiEndpoint}reports/shop-group/shop-menu-sales/`).query(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/reports.js